import { useCallback, useEffect, useRef, useState } from 'react';
import { searchMarkets, searchTraders } from '../utils/api';

export function useSearch() {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState({ markets: [], traders: [] });
  const [searchLoading, setSearchLoading] = useState(false);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const searchContainerRef = useRef(null);
  const searchRequestSeqRef = useRef(0);

  useEffect(() => {
    const term = searchTerm.trim();
    if (!term) {
      setSearchResults({ markets: [], traders: [] });
      setSearchLoading(false);
      setShowSearchDropdown(false);
      return;
    }

    const seq = searchRequestSeqRef.current + 1;
    searchRequestSeqRef.current = seq;
    setSearchLoading(true);

    const timer = setTimeout(async () => {
      try {
        const [marketsRes, tradersRes] = await Promise.all([
          searchMarkets(term),
          searchTraders(term, 5)
        ]);
        if (searchRequestSeqRef.current !== seq) return;
        const markets = Array.isArray(marketsRes?.data?.items) ? marketsRes.data.items : [];
        const traders = Array.isArray(tradersRes?.data?.items) ? tradersRes.data.items : [];
        setSearchResults({ markets, traders });
        setShowSearchDropdown(true);
      } catch (err) {
        if (searchRequestSeqRef.current !== seq) return;
        console.error('[搜索] 请求失败', err);
        setSearchResults({ markets: [], traders: [] });
        setShowSearchDropdown(true);
      } finally {
        if (searchRequestSeqRef.current === seq) {
          setSearchLoading(false);
        }
      }
    }, 250);

    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  // 点击外部关闭搜索下拉
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!searchContainerRef.current) return;
      if (!searchContainerRef.current.contains(event.target)) {
        setShowSearchDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const clearSearch = useCallback(() => {
    setSearchTerm('');
    setSearchResults({ markets: [], traders: [] });
    setShowSearchDropdown(false);
  }, []);

  return {
    searchTerm,
    setSearchTerm,
    searchResults,
    searchLoading,
    showSearchDropdown,
    setShowSearchDropdown,
    searchContainerRef,
    clearSearch
  };
}
